<!------------------------------

      Page Actions

------------------------------->


<ng-container *sbPageAction>
  <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
             classes="btn-default actionButtonMinWidth" (click)="request()" [disabled]="loading" [loading]="loading">
    <sb-icon icon="refresh"></sb-icon>
  </sb-button>
  <ng-container *ngPermissions="permissionService.Permission.network_share_create">
    <ng-template #disabledLink>
      <sb-button classes="btn-success m-0" [disabled]="loading">
        <sb-icon [icon]="'plus'"></sb-icon>&nbsp;<span class="d-none d-sm-inline-block">
          {{'lang.network_share.createNetworkShare' | translate}}</span>
      </sb-button>
    </ng-template>
    <a *ngIf="!loading; else disabledLink" [sbRouterLink]="util.RoutingID.networkShareCreate">
      <sb-button classes="btn-success m-0" [disabled]="loading">
        <sb-icon [icon]="'plus'"></sb-icon>&nbsp;<span class="d-none d-sm-inline-block">
          {{'lang.network_share.createNetworkShare' | translate}}</span>
      </sb-button>
    </a>
  </ng-container>
</ng-container>

<!------------------------------

  Table Wrapper

------------------------------->

<sb-table-wrapper headline="{{'lang.headlines.networkshare' | translate}}" [itemsData]="hierarchies"
                  [options]="options" (optionsChange)="request($event)" [loading]="loading" [itemName]="'networkShares'"
                  [iterateTableRows]="false" [showExactMatch]="false">


  <!------------------------------

    Header More

------------------------------->

  <div header-more>

  </div>

  <!------------------------------

    Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <!--
      <th *ngIf="discussionService.showRibbon || discussionService.showDiscussionSideBar"
          class="sticky-col first-col tableBg"></th>
          -->
      <th>
        {{'lang.globals.id' | translate}}
      </th>
      <th>
        {{'lang.globals.name' | translate}}
      </th>
      <th>
        {{'lang.globals.description' | translate}}
      </th>
      <!--<th>{{'lang.globals.position' | translate}}</th>-->
      <th>
        {{'lang.globals.level' | translate}}
      </th>
      <th>
        {{'lang.globals.filters' | translate}}
      </th>
      <th>
        {{'lang.networkShare.templateData' | translate}}
      </th>
      <th>
        {{'lang.globals.bookings' | translate}}
      </th>
      <th>
        {{'lang.networkShare.bookable' | translate}}
      </th>
      <th>
        {{'lang.networkShare.showOnlineStatus' | translate}}
      </th>
      <th>
        {{'lang.networkShare.showPlaylist' | translate}}
      </th>
      <th>
        {{'lang.networkShare.showPlayouts' | translate}}
      </th>
      <th>
        {{'lang.networkShare.showLogs' | translate}}
      </th>
      <th>
        {{'lang.networkShare.subletable' | translate}}
      </th>
      <th class="tr">
      </th>
    </tr>
  </ng-template>

  <!------------------------------

  Table Body

------------------------------->
  <ng-template #tbody>
    <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: hierarchies, level: 0 }"></ng-container>
  </ng-template>
</sb-table-wrapper>

<ng-template #recursiveListTmpl let-list="list" let-level="level">
  <ng-container *ngFor="let item of list; index as index; last as last">
    <tr *ngIf="isDragging" [attr.data-share]="item?.precondition?.id" (drop)="onDrop($event, index)"
        (dragover)="onDragOver($event)">


      <td colspan="100" class="tw-text-center">
        {{ 'lang.globals.position' | translate }} {{ item.name }}
      </td>
    </tr>
    <tr
      [attr.data-share]="item?.id" (drop)="onDrop($event)" (dragstart)="onDragStart($event)"
        (dragend)="onDragEnd($event)" (dragover)="onDragOver($event)" (dragenter)="isDragging = true"
      [style.background]="isNumberEven(level) ? null : 'rgba(239, 239, 239, .75)'">
      <!--
      <td *ngIf="discussionService.showRibbon || discussionService.showDiscussionSideBar"
          class="sticky-col first-col tableBg" [inline]="true" [inTable]="true"
          sb-discussion [entityElement]="{type: discussionService.DISCUSSABLES.NetworkShare, element: item}">

      </td>
      -->
      <td>
        <div *ngPermissions="permissionService.Permission.network_share_edit" class="btn btn-hover-primary mr-3"
             (mousedown)="onmousedown($event)" (mouseleave)="onmouseup($event)">
          <sb-icon icon="drag"></sb-icon>
        </div>
        <sb-icon *ngIf="item.preconditionOf && item.preconditionOf.length > 0 && showChildren.has(item?.id)" [style.margin-left.px]="level"
                 [icon]="'minus'" class="cursor-pointer"
                 (click)="toggleShowChildren(item)"></sb-icon>
        <sb-icon *ngIf="item.preconditionOf && item.preconditionOf.length > 0 && !showChildren.has(item?.id)" [style.margin-left.px]="level"
                 [icon]="'plus'" class="cursor-pointer"
                 (click)="toggleShowChildren(item)"></sb-icon>
        <sb-icon *ngIf="!(item.preconditionOf && item.preconditionOf.length > 0) && showChildren.has(item?.id)"
                 [style.margin-left.px]="level"
                 [icon]="'minus'" style="opacity: 0;"></sb-icon>
        <sb-icon *ngIf="!(item.preconditionOf && item.preconditionOf.length > 0) && !showChildren.has(item?.id)"
                 [style.margin-left.px]="level"
                 [icon]="'plus'" style="opacity: 0;"></sb-icon>
        &nbsp;
        {{ item.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <span firstLine>
            {{ item.name }}
          </span>
          <span secondLine *ngIf="item.precondition"
                class="text-muted font-weight-bold">{{'lang.globals.basedOn'|translate}}{{item.precondition?.name}}</span>

          <sb-tags
            thirdLine
            *ngPermissions="[permissionService.Permission.tag_list]" [tags]="item.tags"
            [dtoType]="tagService.TaggableDTO.NetworkShare" [dtoId]="item.id">
          </sb-tags>
        </sb-comp-name-wrapper>
      </td>
      <td>
        {{ item.description }}
      </td>
      <!--<td>{{ item.priority }}</td>-->
      <td>
        {{ item.level }}
      </td>
      <td>
        <sb-comp-filter-overview [displayedElements]="['client', 'player']" [playerCull]="item?.playerCull"
                                 [clientCull]="item?.clientCull"></sb-comp-filter-overview>
      </td>
      <td>
        <ng-container *ngIf="item.templateData">
          {{'lang.networkShare.accessOption.' + item.templateData | translate}}
        </ng-container>
        <ng-container *ngIf="!item.templateData">
            <span class="tw-opacity-50">n. def.</span>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="item.bookings">
          {{'lang.networkShare.accessOption.' + item.bookings | translate}}
        </ng-container>
        <ng-container *ngIf="!item.bookings">
            <span class="tw-opacity-50">n. def.</span>
        </ng-container>
      </td>
      <td>
        <sb-network-share-option-status [option]="item.bookable"></sb-network-share-option-status>
      </td>
      <td>
        <sb-network-share-option-status [option]="item.showOnlineStatus"></sb-network-share-option-status>
      </td>
      <td>
        <sb-network-share-option-status [option]="item.showPlaylist"></sb-network-share-option-status>
      </td>
      <td>
        <sb-network-share-option-status [option]="item.showPlayouts"></sb-network-share-option-status>
      </td>
      <td>
        <sb-network-share-option-status [option]="item.showLogs"></sb-network-share-option-status>
      </td>
      <td>
        <sb-network-share-option-status [option]="item.subletable"></sb-network-share-option-status>
      </td>
      <td class="tr sticky-col last-col tableBg">
        <sb-table-buttons>
          <!--          <a *ngPermissions="permissionService.Permission.device_list" [sbRouterLink]="util.RoutingID.networkShareDetails"
                       [pathParams]="[{id: 'networkshareID', value: item?.id}]"
                       ngbTooltip="{{'lang.globals.openDetails' | translate}}" container="body"
                       class="btn btn-primary">
                      <sb-icon icon="details"></sb-icon>
                    </a>-->
          <a *ngPermissions="permissionService.Permission.network_share_edit"
             [sbRouterLink]="util.RoutingID.networkShareEdit"
             [pathParams]="[{id: 'networkshareID', value: item?.id}]"
             ngbTooltip="{{'lang.network_share.editNetworkShare' | translate}}" container="body"
             class="btn btn-secondary">
            <sb-icon icon="edit"></sb-icon>
          </a>
          <button *ngPermissions="permissionService.Permission.network_share_delete"
                  (click)="deleteNetworkShare(item)" [disabled]="item?.preconditionOf?.length > 0"
             ngbTooltip="{{'lang.globals.delete' | translate}}" container="body"
             class="btn btn-danger">
            <sb-icon icon="trash"></sb-icon>
          </button>
        </sb-table-buttons>
      </td>
    </tr>
    <ng-container *ngIf="item?.preconditionOf?.length > 0 && showChildren.has(item?.id)">
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: item.preconditionOf, level: level + 25 }">
      </ng-container>
    </ng-container>
    <tr *ngIf="last && isDragging" [attr.data-share]="item?.precondition?.id" (drop)="onDrop($event, index+1)"
        (dragover)="onDragOver($event)">

      <td colspan="100" class="tw-text-center">
        {{ 'lang.globals.positionAtEnd' | translate }} {{ item.name }}
      </td>
    </tr>
  </ng-container>
</ng-template>
